import React from 'react';
import { Box, Paper, useTheme } from '@mui/material';

const ProjectLayout = ({ sidebar, content }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh', // Full viewport height
        position: 'fixed', // Fix the position
        top: 64, // Height of AppBar
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'background.default'
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: 250,
          flexShrink: 0,
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          overflow: 'auto',
          borderRadius: 0, // Remove border radius
          borderTop: 0, // Remove top border
          height: '100%', // Full height
          position: 'relative', // For proper stacking
          mt: '-1px', // Overlap with AppBar to remove gap
        }}
      >
        {sidebar}
      </Paper>

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          overflow: 'auto',
          height: '100%'
        }}
      >
        {content}
      </Box>
    </Box>
  );
};

export default ProjectLayout;
